import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import avatarImg from '../images/Jesse_avatar.webp';
import { useAuth0 } from '@auth0/auth0-react';

export default function Header() {
  const { loginWithRedirect, logout, isAuthenticated } = useAuth0();

  return (
    <div className="header">
      <div className="hero__text">
        <span className="hai">HAI</span>
        <span className="name">Jesse</span>
      </div>
      <img
        className="hero__avatar"
        src={avatarImg}
        alt="Avatar Jesse"
      />

      {/* Account link */}
      {isAuthenticated && (
        <Link to="/account" className="header__account-link">
          <span className="material-icons">account_circle</span>
        </Link>
      )}

      {!isAuthenticated && (
        <>
          <button
            className="login-btn"
            onClick={() => loginWithRedirect({
              authorizationParams: { screen_hint: 'signup' },
              appState: { returnTo: '/app' }
            })}
            style={{
              background: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)',
              fontWeight: '600'
            }}
            title="Maak gratis account - 7 dagen trial"
          >
            <span className="logout-text">Gratis Starten</span>
          </button>
          <button
            className="login-btn"
            onClick={() => loginWithRedirect({ appState: { returnTo: '/app' } })}
            style={{ background: 'rgba(255,255,255,0.15)' }}
          >
            <span className="logout-text">Login</span>
          </button>
        </>
      )}
      {isAuthenticated && (
        <button
          className="logout-btn"
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
        >
          <span className="logout-text">Logout</span>
          <span className="logout-icon material-icons">logout</span>
        </button>
      )}
    </div>
  );
}